var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.cls},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,class:_vm.matched(item)?'active':'',on:{"click":function($event){return _vm.onClick(item)}}},[_c('span',[_vm._v(_vm._s(item[_vm.prop]))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }